import { taggedTemplateLiteral as _taggedTemplateLiteral } from './_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject, _templateObject2;
var ContainerDefinition = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: 15px;\n  padding-left: 15px;\n  width: 100%;\n\n  @media (min-width: 1200px) {\n    max-width: 1140px;\n  }\n\n  @media (min-width: 768px) and (max-width: 1199px) {\n    max-width: 768px;\n  }\n\n  @media (max-width: 767px) {\n    max-width: 375px;\n  }\n"])));
ContainerDefinition.displayName = "Container";
var Container = ContainerDefinition;
var FlexRowDefinition = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin: 20px 0;\n"])));
FlexRowDefinition.displayName = "FlexRow";
var FlexRow = FlexRowDefinition;

export { Container, FlexRow, FlexRowDefinition };
